document.addEventListener("DOMContentLoaded", function () {
    function searchChains() {
        // 获取并处理用户输入
        let input = document.getElementById('tire-size-input').value.trim();
        let alphanumericInput = input.replace(/[^0-9]/g, ''); // 允许数字

        // 检查输入是否为空
        if (alphanumericInput === '') {
            alert('Please enter a valid tire size.');
            return;
        }

        // 构建带有标签筛选器的集合页面 URL
        const url = `/collections/all?filter.p.tag=${encodeURIComponent(alphanumericInput)}`;
        window.location.href = url;
    }

    // 按钮点击事件
    document.getElementById('find-chains-btn').addEventListener('click', function (e) {
        e.preventDefault();
        searchChains();
    });

    // 回车键监听事件
    document.getElementById('tire-size-input').addEventListener('keypress', function (e) {
        if (e.key === 'Enter') { // 检测是否按下 Enter 键
            e.preventDefault(); // 阻止默认行为（避免表单提交）
            searchChains();
        }
    });
});

document.addEventListener("DOMContentLoaded", function () {
    const infoButton = document.getElementById("tire-size-info-btn");
    const infoText = document.getElementById("tire-size-info-text");
    const infoPopup = document.getElementById("tire-size-info");

    function togglePopup() {
        if (infoPopup.style.display === "none" || infoPopup.style.display === "") {
            infoPopup.style.display = "block";
        } else {
            infoPopup.style.display = "none";
        }
    }

    // 点击按钮或文本都触发弹出图片
    infoButton.addEventListener("click", togglePopup);
    infoText.addEventListener("click", togglePopup);
});